import axios from 'axios'
export default axios



// WEBPACK FOOTER //
// ./src/api/request.js